import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  salesTypes: string[];
  defaultValues?: any;
}

export default function Form8({ defaultValues, ...props }: Props) {
  const { handleSubmit, errors, register } = useForm({
    defaultValues: replaceDefaultValues(
      {
        salesType: '',
      },
      defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Tipo de venta</h1>

      <FormElement
        name="salesType"
        label="Selecciona si la propiedad ya está construida O se encuentra sobre planos*"
        inputRef={register({ required: true })}
        error={errors.salesType}
        elementType="radio"
        elements={props.salesTypes.map((el) => ({ name: el, value: el }))}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
